import React , {useState} from "react";
import { slide as Menu } from "react-burger-menu";

import { Route, Routes, Link, BrowserRouter } from "react-router-dom";

import facebook from "../../../assets/facebook.png";
import instagram from "../../../assets/instagram.png";
import youtube from "../../../assets/youtube.png";
import linkedIn from "../../../assets/linkedIn.png";
import twitter from "../../../assets/twitter.png";

import "./sideBar.css";

const SideBar = (props) => {

    const [openMenu, setopenMenu] = useState(false)

    const rsvp = () => {
        setopenMenu(false)

        window.open('https://mcdtdcubx05.typeform.com/to/icUO5tQR','_blankl')
    }

  return (
    <Menu isOpen={ openMenu }>
      <Link className="menu-item" to="/aboutClp" onClick={()=>props.setopenMenu(false)}>
        ABOUT CLASSPLUS
      </Link>
      <Link className="menu-item" to="/aboutAnant" onClick={()=>props.setopenMenu(false)}>
        ABOUT ANANT LADHA
      </Link>
      <Link className="menu-item" to="/contactUs" onClick={()=>props.setopenMenu(false)}>
        CONTACT US
      </Link>
      <Link className="menu-item" style={{ marginTop: "20%" }} to="/" onClick={()=>props.setopenMenu(false)}>
        About Event
      </Link>

      <div className="menu-item" to="/desserts" onClick={()=>rsvp()}>
        RSVPs
      </div>

      <div className="mb-social-conatiner">
        <img src={facebook} className="facebook" onClick={()=>{window.open('https://www.facebook.com/classplusapp/','_blank')}}/>
        <img src={instagram} className="instagram" onClick={()=>{window.open('https://instagram.com/classplusculture?utm_medium=copy_link', "_blank")}}/>
        <img src={youtube} className="youtube" onClick={()=>{window.open('https://www.youtube.com/channel/UCp0yDDnyu-C-0Bo_y1JbGtA','_blank')}} />
        <img src={linkedIn} className="linkedin" onClick={()=>{window.open('https://www.linkedin.com/company/classplus', '_blank')}}/>
        <img src={twitter} className="twitter" onClick={()=>{window.open('https://twitter.com/classplusapps?lang=en', '_blank')}}/>
      </div>
    </Menu>
  );
};

export default SideBar;
